import React from 'react';
import axios from 'axios';

import * as Globals from './Globals';
import Login from './Login';
import AdminView from './admin/AdminView';
import UserView from './user/UserView';


export default class Layout extends React.Component {

    constructor() {
        super();

        this.userID = null;
        this.role = "";
        this.firstname = "";
        this.lastname = "";
        this.sex = "";
        this.cookie_value = "";
        this.state = {
            key: 0
        };

        this.LogoutOnCookieNotSet = this.LogoutOnCookieNotSet.bind(this);
        this.CheckAuthError = this.CheckAuthError.bind(this);
    }


    LogoutOnCookieNotSet() {
		let cookie = '; ' + document.cookie;
		let parts = cookie.split('; ' + Globals.COOKIE_KEY + '=');
		if (parts.length === 2) {
            let value = parts.pop().split(';').shift();

            if (value === '') {
                this.role = "LOGIN";
                this.setState({key: Math.random()});
            }
            return value;
        } else {
            this.role = "LOGIN";
            this.setState({key: Math.random()});
        }
    }

    CheckAuthError(error) {
        console.error(error);
        if (error.response.status === 401 || error.response.status === 403)
            this.handleLogoutEvent();
    }

    componentDidMount() {
        let cookie_value;
        let cookie = '; ' + document.cookie;
        let parts = cookie.split('; ' + Globals.COOKIE_KEY + '=');
        if (parts.length === 2) {
            let value = parts.pop().split(';').shift();
            if (value === '') {
                this.role = "LOGIN";
                this.setState({key: Math.random()});
                return;
            }
            cookie_value = value;
        } else {
            this.role = "LOGIN";
            this.setState({key: Math.random()});
            return;
        }

        axios.get(Globals.BASE_PATH + 'api/user',
            {
                headers: {
                    'Accept': 'application/json',
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + cookie_value
                }
            }).then(response => {
            this.userID = response.data.data.id;
            this.firstname = response.data.data["personal-data"].firstName;
            this.lastname = response.data.data["personal-data"].lastName;
            this.sex = response.data.data["personal-data"].sex;
            this.role = response.data.data.role.roleRaw;
            this.setState({key: Math.random()});
        }).catch(error => {
            this.CheckAuthError(error);
        });
    }

    handleLoginEvent() {
        this.componentDidMount();
    }

    handleLogoutEvent() {
        document.cookie = Globals.COOKIE_KEY +"=;path=/;domain="+Globals.COOKIE_DOMAIN+";expires=0";
        this.componentDidMount();
    }

    renderBlock() {
        if (this.role === "") {
            return null;
        }
        if (this.role === "LOGIN") {
            return <Login CheckAuthError={ this.CheckAuthError } handleLoginEvent={ this.handleLoginEvent.bind(this) } />;
        }
        if (this.role === "ADMIN" || this.role === "ASSITENT" || this.role === "TRAINER" || this.role === "SECRETARY") {
            return <AdminView firstname={ this.firstname } lastname={ this.lastname } sex={ this.sex } CheckAuthError={ this.CheckAuthError } LogoutOnCookieNotSet={ this.LogoutOnCookieNotSet } handleLogoutEvent={ this.handleLogoutEvent.bind(this) } />;
        }
        if (this.role === "COURSE_PARTICIPANT") {
            return <UserView firstname={ this.firstname } lastname={ this.lastname } sex={ this.sex } CheckAuthError={ this.CheckAuthError } LogoutOnCookieNotSet={ this.LogoutOnCookieNotSet } userID={ this.userID } handleLogoutEvent={ this.handleLogoutEvent.bind(this) } />;
        }
    }

    render(){
        return(
            <div>
                { this.renderBlock() }
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/Layout.js